module.exports = __webpack_public_path__ + "img/bg1.6799b4c1.png";